import {ENDPOINT_REFDATA} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

const getItemsByItemCodes = (token, itemCodes) => {
  return fetch(`${ENDPOINT_REFDATA}items/${itemCodes}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};
const getTypesByItemCodes = (token) => {
  return fetch(`${ENDPOINT_REFDATA}codes/APPLICATION_TYPE`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getCountiesByState = (state, token) => {
  return fetch(`${ENDPOINT_REFDATA}counties?state=${state}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getPrefixes = () => {
  return fetch(`${ENDPOINT_REFDATA}codes/PREFIX`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};
const getCodelist = (codelist) => {
  return fetch(`${ENDPOINT_REFDATA}codes/${codelist}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};
export default {
  getItemsByItemCodes,
  getTypesByItemCodes,
  getPrefixes,
  getCountiesByState,
  getCodelist,
};
